<template>
    <div style="background-color: #EFEFEF;">
        <HomeMar></HomeMar>
        <ContactMar></ContactMar>
        <FooterMar></FooterMar>
    </div>
</template>

<style lang="stylus">

</style>

<script>
import HomeMar from './HomeMar'
import ContactMar from './ContactMar'
import FooterMar from './FooterMar'

export default {
    name: 'PageMar',
    components: {
        HomeMar,
        ContactMar,
        FooterMar
    },
    watch: {
        $route: {
            immediate: true,
            handler(to) {
                document.title = to.meta.title || 'Mar by Marabunta';
                const link = document.querySelector("[rel='icon']")
                link.setAttribute('href',to.meta.icon || '/faviconM.png')
            }
        },
    }
}
</script>